// nav-section — wireframe skin module
// Token disposition: color tokens overridden to wf-* namespace; spacing/sizing pass-through

export const styles = `
  :host {
    display: block;
    background: var(--run-wf-surface);
    color: var(--run-wf-text);
  }

  [part="trigger"] {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-block: var(--run-nav-section-padding-block, var(--run-space-semantic-xs));
    padding-inline: var(--run-nav-section-padding-inline, var(--run-space-semantic-xs));
    gap: var(--run-nav-section-gap, var(--run-space-semantic-xs));
    background: transparent;
    border: none;
    cursor: pointer;
    text-align: start;
    box-sizing: border-box;
    font-family: var(--run-wf-font-family);
    font-weight: 400;
  }

  [part="trigger"]:hover {
    background: var(--run-wf-surface-hover);
  }

  [part="trigger"]:focus-visible {
    outline: 1px dashed var(--run-wf-border);
    outline-offset: -2px;
  }

  [part="label"] {
    flex: 1;
    color: var(--run-wf-text-secondary);
    font-size: var(--run-nav-section-label-font-size, var(--run-font-size-sm));
    font-weight: 400;
    font-family: var(--run-wf-font-family);
  }

  :host([data-level="0"]) [part="label"] {
    font-size: var(--run-nav-section-label-size, 0.6875rem);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  [part="chevron"] {
    color: var(--run-wf-text-secondary);
    transition:
      transform var(--run-nav-section-motion-duration, var(--run-motion-semantic-micro-duration))
      var(--run-nav-section-motion-easing, var(--run-motion-semantic-micro-easing));
    flex-shrink: 0;
  }

  :host([expanded]) [part="chevron"] {
    transform: rotate(90deg);
  }

  [part="panel"] {
    overflow: hidden;
    height: 0;
    transition:
      height var(--run-nav-section-motion-duration, var(--run-motion-semantic-micro-duration))
      var(--run-nav-section-motion-easing, var(--run-motion-semantic-micro-easing));
  }

  :host([expanded]) [part="panel"] {
    height: var(--run-nav-section-measured-height, auto);
  }

  [part="region"] {
    padding-inline-start: calc(
      var(--run-nav-section-indent, 0.5rem) * var(--run-nav-section-level, 0)
    );
    border-top: 1px dashed var(--run-wf-border);
  }
`;

export function render(host) {
  const { label, expanded, level, _regionId } = host;

  const panelId = _regionId || 'run-nav-section-panel';
  const ariaExpanded = expanded ? 'true' : 'false';
  const levelClass = level === 0 ? 'label--level-0' : 'label--level-n';

  host.shadowRoot.innerHTML = `
    <button
      part="trigger"
      aria-expanded="${ariaExpanded}"
      aria-controls="${panelId}"
    >
      <run-text part="label" class="${levelClass}">${label ?? ''}</run-text>
      <run-icon part="chevron" name="chevron-right" aria-hidden="true"></run-icon>
    </button>
    <div part="panel">
      <run-stack
        id="${panelId}"
        part="region"
        role="region"
        aria-label="${label ?? ''}"
      >
        <slot></slot>
      </run-stack>
    </div>
  `;
}